const styles = {
  container: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "start",
    height: "100vh",
    padding: "8px",
    backgroundColor: "var(--bg)",
    width: "100%", // Ensures the container takes full width
    boxSizing: "border-box", // Ensures padding is included in width
  },
  title: {
    color: "var(--text)",
    fontSize: "24px",
    marginBottom: "20px",
  },
  taskList: {
    width: "100%", // Make taskList full-width on mobile
    maxWidth: "600px", // Limit max width on larger screens
    flexGrow: 1,
    overflowY: "auto",
    display: "flex",
    flexDirection: "column",
    gap: "8px",
    padding: "0", // Ensure padding fits within mobile screens
    boxSizing: "border-box",
    marginBottom: "20px",
  },
  taskItemContainer: {
    width: "100%", // Make each task item container full width
    borderRadius: "8px",
  },
};

export default styles;
